import React, { useContext, useEffect, useState } from 'react';
import { Button, Container, Typography } from '@mui/material';
import '../../App.css'
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import api from '../../connection/Axios';
import icoTeam from '../../assets/icoTeam.png'
import icoCheck1 from '../../assets/icoCheck1.png'
import icoCheck2 from '../../assets/icoCheck2.png'
import icoMailOn from '../../assets/icoMailOn.png'
import icoMailOff from '../../assets/icoMailOff.png'
import icoArrowDashboard2 from '../../assets/icoArrowDashboard2.png'
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { Chart } from "react-google-charts";
import allCompaniesArrow from '../../assets/allCompaniesArrow.png'



const Dashboard = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [inspecoes, setInspecoes] = useState([])
  const [ocorrencias, setOcorrencias] = useState([])
  const [mensagens, setMensagens] = useState([])
  const [nrs, setNrs] = useState([])
  const [equipe, setEquipe] = useState([])
  const [vistorias, setVistorias] = useState([])
  const [company, setCompany] = useState([])
  const [companies, setCompanies] = useState([])
  const [checklist, setChecklist] = useState([])
  const [graphDatal, setGraphData] = useState([])
  const [openAll, setOpenAll] =  useState('')
  

  const mes = moment(new Date()).format('MMMM / YYYY')

  const chartOptions = {
    title: mes,
    pieHole: 0.4,
    is3D: true,
    colors: ["#e5e5e5", "#ff9c6a", "#b90c0c", "#479b5f"],
  };

  const chartData = [
    ["Semana", "Não iniciados", "Pendentes", "Atenção", "Resolvidos"],
    ["22/12", 14, 4, 23, 9],
    ["29/12", 8, 1, 3, 6],
    ["05/01", 18, 3, 12, 8],
    ["12/01", 2, 1, 0, 7],
  ];


  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};


    useEffect(()=>{
      GetOChecklist()
      GetCompanies()
      GetInspecoes()
      GetServices()
    }, [company])

    const data = {
      company: userData?.role === 'cliente' || userData.role === 'clienteAdm' ? userData?.companyId : company[0]
    }    

    async function GetInspecoes() {
      api.post('dashboard/inspecoes', data, headers).then(response => {
        setInspecoes(response.data)
        GetOcorrencias()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
  
    async function GetOcorrencias() {
      api.post('dashboard/ocorrencias', data, headers).then(response => {
        setOcorrencias(response.data)
        GetEquipe()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
  
    async function GetOChecklist() {
      api.post('dashboard/checklist', data, headers).then(response => {
        setChecklist(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
  
    async function GetEquipe() {
      api.post('dashboard/equipe', {companyId: data.company}, headers).then(response => {
        setEquipe(response.data)
        GetMensagens()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
      
    async function GetMensagens() {
      api.post('dashboard/mensagens', {companyId: data.company}, headers).then(response => {
        setMensagens(response.data)
        GetNrs()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }

      
    async function GetNrs() {
      api.post('dashboard/nrs', data, headers).then(response => {
        setNrs(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
      
    async function GetCompanies() {
      api.get('dashboard/companies', headers).then(response => {
        setCompanies(response.data)
        GetChartData()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }

    async function GetChartData() {
      await api.post('dashboard/graficoSemana', {companyId: data.company}, headers).then(response => {
        setGraphData(response.data)
      }).catch(error => {
        console.log(error.message)
      })
    }


    async function GetServices() {
      api.post('vistoria/getServices', {company: data.company}, headers).then(response => {
        setVistorias(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }



    function OpenPopup(value) {
      let comp = userData.role === 'cliente' || userData.role === 'clienteAdm' ? [userData.companyId, userData.companyName] : value
      setCompany(comp)
      setOpenAll(!openAll)
    }

    useEffect(()=>{
      GetServices()
    }, [company])


  const Box = (props) => {
    const largura = props.largura

    return(
      <div style={{display: 'flex',
          backgroundColor: props.cor,
          borderRadius: 12,
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: props.borda,
          width: largura,
          height: 80,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          color: props.corFonte,
          fontSize: props.txtP === 'inspeções' ? 13 : 16
        }}>
          <div style={{display: 'flex', flexDirection: props.txtP === 'inspeções' ? 'column' : 'row', alignItems: 'center', justifyContent: props.txtP === 'inspeções' ? null : 'space-around'}}>
            <span style={{color: props.corFonte, fontSize: 35, marginRight: props.txtP === 'inspeções' ? 0 : 10}}>{props.txtG}</span> {props.txtP}  
          </div>
      </div>
    )
  }

  console.log('Mensagens', mensagens)

  return (
    <>
        <Layout breadcrumb=' ' style={{backgroundColor: '#ffffff'}}>
          {userData.role === 'cliente' || userData.role === 'clienteAdm' ? <div style={{marginTop: -30}}></div> :
            <div style={{marginTop: -34, marginBottom: 30}}>
              <button className='buttonFonte' onClick={()=>{setOpenAll(!openAll)}} style={{cursor: 'pointer', backgroundColor: '#ffffff', width: 450, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: 30, paddingRight:30, padding: 15, borderRadius: 8, borderColor: '#aaaaaa', borderWidth: 1, borderStyle: 'solid'}}>
                {company?.length > 0 ? company[1] : 'Selecione uma empresa'}
                <img src={allCompaniesArrow} style={{width: 25, marginRight: 10}} />
              </button>
            
            {openAll ? 
            <div style={{alignItems: 'flex-start', justifyContent: 'flex-start', width: 400, marginLeft: 10, backgroundColor: '#ffffff', borderTopColor: '#ffffff', position: 'absolute', zIndex: 12, display: 'flex', flexDirection: 'column', padding: 15, borderBottomRightRadius: 8, borderBottomLeftRadius: 8, borderColor: '#aaaaaa', borderWidth: 1, borderStyle: 'solid'}}>
                <button className='buttonFonte' onClick={()=>{OpenPopup(([null, 'Todas as empresas']))}} style={{cursor: 'pointer', backgroundColor: '#ffffff', border:0, padding: 10}}>Todas as empresas</button>
                {companies.length != 0 ? companies.map((item, index) => (
                  <button key={index} onClick={()=>{OpenPopup(([item.company, item.nome]))}} style={{cursor: 'pointer', backgroundColor: '#ffffff', border:0, padding: 10}}>{item.nome}</button>
                )) : null}
            </div>
            : null}
            </div>
          }
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
            <Box title={'Não iniciados'} largura={86} borda='#050741' cor='#050741' corFonte='#ff6400' txtG={inspecoes.inspecoes} txtP='inspeções' />
            <Box title={'Não iniciados'} largura={150} borda='#c2c2c2' cor='#f8f8f8' corFonte='#bdbdbd' txtG={inspecoes.naoiniciadas} txtP='não iniciadas' />
            <Box title={'Pendentes'} largura={150} borda='#ff6400' cor='#fffbf8' corFonte='#ff6400' txtG={inspecoes.pendentes} txtP='pendentes' />
            <Box title={'Atenção'} largura={150} borda='#b90c0c' cor='#fff8f8' corFonte='#b90c0c' txtG={inspecoes.atencao} txtP='atenção' />
            <Box title={'Concluídos'} largura={150} borda='#067500' cor='#f6fff6' corFonte='#067500' txtG={inspecoes.resolvidas} txtP='concluídas' />
          </div>

          <div style={{display: 'flex', flexDirection: 'row', height: 72, alignItems: 'center', justifyContent: 'space-between', marginTop: 20, marginBottom: 40}}>
            <div style={{width:160}}>
                <div style={{backgroundColor: '#ff6400', width: 151, height: 72, borderRadius: 12}}>
                  <img src={icoTeam} style={{width: 75, marginLeft: 72, marginTop: 13, zIndex: 1}} />
                  <div style={{color: '#ffffff', fontSize: 14, zIndex: 3, marginLeft: 20, marginTop: -64}}>
                    {equipe.tecnico} técnicos<br />
                    {equipe.admin} administradores<br />
                    {equipe.cliente} clientes
                  </div>
                </div>    
            </div>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap'}}>
              <div style={{backgroundColor: '#efefef', width: 335, height: 32, borderRadius: 8, margin: 3, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                <span style={{marginLeft: 45}}><b>{checklist.totalNr} </b></span> <span style={{color: '#777777', marginLeft: 5}}>Normas em checklists</span>
                <img src={icoCheck1} style={{width: 20, marginLeft: 20}} />
              </div>
              <div style={{backgroundColor: '#efefef', width: 335, height: 32, borderRadius: 8, margin: 3, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                  <span style={{marginLeft: 45}}><b>{mensagens.totalMensagens} </b></span> <span style={{color: '#777777', marginLeft: 5}}>Notificações enviadas</span>
                  <img src={icoMailOff} style={{width: 20, marginLeft: 20}} />
              </div>
              <div style={{backgroundColor: '#efefef', width: 335, height: 32, borderRadius: 8, margin: 3, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                    <span style={{marginLeft: 45}}><b>{checklist.c} </b></span> <span style={{color: '#777777', marginLeft: 5}}>NRs em conformidade</span>
                    <img src={icoCheck2} style={{width: 20, marginLeft: 20}} />
              </div>
              <div style={{backgroundColor: '#efefef', width: 335, height: 32, borderRadius: 8, margin: 3, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                    <span style={{marginLeft: 45}}><b>{mensagens.lidas}</b> </span> <span style={{color: '#777777', marginLeft: 5}}>Notificações lidas</span>
                    <img src={icoMailOn} style={{width: 20, marginLeft: 20}} />
              </div>
            </div>

          </div>
{/* VISTORIAS MAIS RECENTES */}          
        {vistorias.length > 0 ?
        <>
           <div style={{marginTop: 45,backgroundColor: '#efefef', borderRadius: 8,  margin: 3, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid'}}>
            <div style={{color: '#000000', fontSize: 18, marginLeft: 10, paddingLeft: 20, padding: 8}}>Inspeções mais recentes</div>
          </div>

          <div style={{paddingTop: 10, paddingBottom: 10}}>
            {vistorias?.filter((item, idx) => idx < 10).map((vistoria, index)=>(
              <div key={index} style={styles.item}>
                <div style={{color: '#262525', width: 80}}><span style={{fontSize: 20}}>
                  {moment(vistoria.dataHora).format('D')}</span> {moment(vistoria.dataHora).format('MMM')}
                </div>
                <div style={{color: '#000000', fontSize: 14, fontWeight: 600, width: 100}}>{vistoria.status}</div>
                <div style={{color: '#ff6400', fontSize: 14, fontWeight: 600, width: 220}}>{vistoria.empreend}</div>
                <div style={{color: '#a37272', fontSize: 12, width: 240}}>{vistoria.addressStreet}, {vistoria.addressNum}</div>
                <Button component={Link} to="/vistoria-detalhe" state={{data: vistoria}}><img src={icoArrowDashboard2} style={{width: 20, tintColor: '#ff6400'}} /></Button>
              </div>
            ))}
          </div>
        </>
        : 
          <div style={{marginTop: 45,backgroundColor: '#efefef', borderRadius: 8,  margin: 3, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid'}}>
            <div style={{color: '#a37272', fontSize: 13, fontWeight: 6000, padding: 8}}>Não há inspeções para esta empresa</div>
          </div>
        }
           <div style={{marginTop: 35,backgroundColor: '#efefef', borderRadius: 8,  marginBottom: 30, borderColor: '#c2c2c2', borderWidth: 1, borderStyle: 'solid'}}>
            <div style={{color: '#000000', fontSize: 18, marginLeft: 10, paddingLeft: 20, padding: 8}}>Acompanhamento semanal</div>
          </div>

          <div>
            <Chart
              chartType="Bar"
              width="99%"
              height="300px"
              data={chartData}
              options={chartOptions}
            />
          </div>

          
        </Layout>
    </>
  );
};

export default Dashboard;

const styles = {
  botaozinho: {
    display: 'flex',
    position: 'absolute',
    zIndex: 20,
    marginLeft: 110,
    marginTop: 60
  },
  item: {
    backgroundColor: '#f7f7f7',
    marginTop: 7,
    marginBottom: 8,
    paddingLeft: 15,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}
